const configFieldsExpeditionServices = [
  {
    key: 'shipping_name',
    label: 'Expedition',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'start',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
  },
  {
    key: 'is_regular',
    label: 'Regular',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'center',
    },
    tdClass: 'justify-items-center',
  },
  {
    key: 'is_cargo',
    label: 'Cargo',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'center',
    },
    tdClass: 'justify-items-center',
  },
  {
    key: 'is_lite',
    label: 'Lite',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'center',
    },
    tdClass: 'justify-items-center',
  },
  {
    key: 'is_flat',
    label: 'Flat',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'center',
    },
    tdClass: 'justify-items-center',
  },
]

export default configFieldsExpeditionServices
